import React from 'react';

import styles from './PopUpDeleteDraft.module.scss';
import axiosHelper from '../../../helpers/axiosHelper';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ROUTEPATHS } from '../../../routes/routePaths';
import { DesignDetails, User } from '../../../global';
import CloseButton from '../../CloseButton/CloseButton';

interface PopUpLoginProps {
  popup: boolean;
  close: () => void;
  design: DesignDetails;
  loggedUser: User | null;
}

const PopUpDeleteDraft: React.FC<PopUpLoginProps> = (props) => {
  const redirect = useNavigate();

  const deleteDraft = () => {
    axiosHelper.deleteDraft(props.design.id).then((response) => {
      console.log(response);
      redirect(`/${ROUTEPATHS.COMMUNITY}/${props.loggedUser!.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`);
      props.close();
    });
  };

  return (
    <Modal show={props.popup} onHide={props.close} centered contentClassName={styles.rounded}>
      <Modal.Body className={`${styles.body} bg-light-gray p-4`}>
        <div className="d-flex justify-content-end w-100">
          <CloseButton callback={props.close} />
        </div>

        <div className="mb-4 text-center">
          <span className="text-16 fw-bold">Are you sure you want to delete this design?</span>
        </div>

        <p className={`${styles.copy} text-16`}>You can't undo this action and your design will be discarded.</p>

        <div className="d-flex justify-content-center mt-4">
          <button className={`${styles.actionButton} btn-danger rounded mb-3`} onClick={deleteDraft}>
            Delete draft
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PopUpDeleteDraft;
